



















import { Component, Prop, Vue } from 'vue-property-decorator';
import ExtLink from '@/components/ext/Link.vue';
import Button from '@/components/ext/Button.vue';
import { IUrl } from './types';

@Component({
  components: {
    ExtLink,
    Button,
  },
})
export default class ComponentsUseCookie extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly border!: false;

  @Prop({ type: Object, default: () => {} })
  readonly url!: IUrl;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/usecookie/UseCookie.vue